import React from 'react'

import { getUserAdvertisements } from 'core'

import useCarousel from 'common/hooks/useCarousel'

import { Button, Carousel, Icon, Tag } from 'common/components'
import { useBreakPoints, useQueryRequest } from 'common/hooks'

import MarketplaceCard from './common/marketplaceCard'

function Marketplace() {
  const [advertisements] = useQueryRequest(null, () => getUserAdvertisements())
  const { isMd } = useBreakPoints()
  const advertisementsLenght = advertisements?.length
  const { carouselRef, currentSlideIndex, slidesNumber, goToNextSlide, goToPreviousSlide, handleCurrentSlideIndex } =
    useCarousel(advertisementsLenght, 3)

  return (
    advertisements &&
    advertisementsLenght > 0 && (
      <div>
        <div className="flex mb-16">
          <div className="font-20 text-semi-bold color-gray-9 mr-8">Marketplace</div>
        </div>

        <Carousel
          carouselRef={carouselRef}
          slidesToShow={slidesNumber}
          slidesToScroll={slidesNumber}
          infinite={false}
          className="mb-8 m-8-negative"
          dots={false}
          swipeToSlide
          afterChange={handleCurrentSlideIndex}
          responsive={[
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ]}
        >
          {advertisements.map((advertisement) => (
            <MarketplaceCard advertisement={advertisement} />
          ))}
        </Carousel>
        {/*<div className="flex_space_between flex__align_center">*/}
        {/*  <div className="flex">*/}
        {/*    <Button*/}
        {/*      className="mr-8"*/}
        {/*      size="default"*/}
        {/*      htmlType="button"*/}
        {/*      type="default"*/}
        {/*      disabled={currentSlideIndex === 0}*/}
        {/*      onClick={goToPreviousSlide}*/}
        {/*    >*/}
        {/*      <Icon type="fa fa-arrow-left" fontAwesome />*/}
        {/*    </Button>*/}
        {/*    <Button*/}
        {/*      size="default"*/}
        {/*      htmlType="button"*/}
        {/*      type="default"*/}
        {/*      disabled={currentSlideIndex + slidesNumber === advertisementsLenght}*/}
        {/*      onClick={goToNextSlide}*/}
        {/*    >*/}
        {/*      <Icon type="fa fa-arrow-right" fontAwesome />*/}
        {/*    </Button>*/}
        {/*  </div>*/}
        {/*  <div className="color-gray-7 font-14">*/}
        {/*    Showing {isMd ? `${currentSlideIndex + 1}-${currentSlideIndex + slidesNumber}` : `${currentSlideIndex + 1}`}{' '}*/}
        {/*    of {advertisementsLenght} total offers*/}
        {/*  </div>*/}
        {/*</div>*/}
      </div>
    )
  )
}

export default Marketplace
